import { DashboardContent, SideMenu } from '@fukuri-admins/ui/common';
import { ComponentProps, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { getCurrentCompany } from '~/apis/companies';
import { GlobalHeader } from '~/components/common/GlobalHeader';
import { CompanyType } from '~/types/resources/CompanyType.ts';
import CLIENT_ICON from '../../../assets/icons/client.svg';
import COMPANY_ICON from '../../../assets/icons/company.svg';
import REPORT_ICON from '../../../assets/icons/report.svg';
import USAGE_ICON from '../../../assets/icons/usage.svg';
import { useIsMobile } from '../../../hooks/useIsMobile';
import {
  getCompanyDepositsLink,
  getCompanyLink,
  getPaymentReportLink,
  getRedeemableStoreCouponHistoriesLink,
} from '../../../utils/getLinks';
import { useAuth } from '../../auth/AuthProvider';
import { BottomNavMenu } from '../../common/BottomNavMenu';
import { BOTTOM_NAV_MENU_ITEMS, LOGO_IMG } from './constants';
import styles from './styles.module.scss';

const SIDE_MENU_ITEMS: ComponentProps<typeof SideMenu>['menus'] = [
  {
    icon: <img src={COMPANY_ICON} alt='ギフト利用ダッシュボード' />,
    content: 'ギフト利用ダッシュボード',
    link: getPaymentReportLink(),
  },
  {
    icon: <img src={USAGE_ICON} alt='地域ギフト利用履歴' />,
    content: '地域ギフト利用履歴',
    link: getRedeemableStoreCouponHistoriesLink(),
  },
  {
    icon: <img src={REPORT_ICON} alt='入金一覧' />,
    content: '入金一覧',
    link: getCompanyDepositsLink(),
  },
  {
    icon: <img src={CLIENT_ICON} alt='事業者情報' />,
    content: '事業者情報',
    link: getCompanyLink(),
  },
];

export function DashboardLayout() {
  const isMobile = useIsMobile();
  const [companyName, setCompanyName] = useState<CompanyType['name']>('');

  const { signOut } = useAuth();
  const getCompanyData = async () => {
    const companyData = await getCurrentCompany(signOut);
    setCompanyName(companyData.company.name);
  };

  useEffect(() => {
    getCompanyData();
  }, []);

  return (
    <div className={styles.DashboardLayout}>
      {isMobile ? (
        <>
          <GlobalHeader />
          <BottomNavMenu menus={BOTTOM_NAV_MENU_ITEMS} />
        </>
      ) : (
        <SideMenu
          imageUrl={LOGO_IMG}
          menus={SIDE_MENU_ITEMS}
          displayName={companyName}
          signOut={signOut}
        >
          <div className={styles.DashboardLayout__SideMenuFooter}>掲載企業管理画面</div>
        </SideMenu>
      )}
      <DashboardContent copyrightCompanyName='Leafea, Inc.'>
        <Outlet />
      </DashboardContent>
    </div>
  );
}
